import { Link } from "react-router-dom";
import { films } from "@/mocks/films";

export default function LatestUpdates() {
  const latest = [...films]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 6);

  return (
    <aside className="flex flex-col gap-5 lg:sticky lg:top-[88px] lg:self-start">
      <div className="rounded-lg border border-background-200/90 bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3.5">
          <div className="flex items-center gap-2">
            <span className="flex h-6 w-6 items-center justify-center rounded bg-primary-500 text-background-50">
              <i className="ri-time-line text-xs" />
            </span>
            <h2 className="text-[14px] font-semibold text-foreground-950">最新更新</h2>
          </div>
          <span className="flex items-center gap-1 text-[10px] text-foreground-400">
            <span className="h-1.5 w-1.5 animate-soft-pulse rounded-full bg-accent-500" />
            实时
          </span>
        </div>

        <ul className="divide-y divide-background-100">
          {latest.map((film, index) => (
            <li key={film.id}>
              <Link to={`/detail/${film.id}`} className="group flex gap-3 px-4 py-3 transition-colors hover:bg-background-100/70">
                <span className="mt-0.5 w-4 shrink-0 font-heading text-[13px] text-foreground-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="h-14 w-10 shrink-0 overflow-hidden rounded bg-background-200">
                  <img
                    src={film.poster}
                    alt={`${film.title} 海报`}
                    title={`${film.title} 韩国影视作品`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="line-clamp-1 text-[13px] font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                    {film.title}
                  </p>
                  <p className="mt-1 line-clamp-1 text-[11px] text-foreground-500">
                    {film.genres.slice(0, 2).join(" / ")} · {film.year}
                  </p>
                  <p className="mt-1 flex items-center gap-1 text-[10px] text-foreground-400">
                    <i className="ri-time-line" />
                    {film.updatedAt} · {film.status}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>

        <Link
          to="/category"
          className="flex items-center justify-center gap-1 border-t border-background-200 py-3 text-[12px] text-foreground-600 transition-colors hover:text-primary-700"
        >
          查看全部更新
          <i className="ri-arrow-right-line text-xs" />
        </Link>
      </div>

      <div className="rounded-lg border border-accent-200 bg-accent-50 p-4">
        <div className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded bg-accent-500 text-primary-950">
            <i className="ri-calendar-check-line text-sm" />
          </span>
          <h3 className="text-[13px] font-semibold text-accent-900">本周资料整理</h3>
        </div>
        <div className="mt-3 grid grid-cols-3 gap-2 text-center">
          {[
            { value: "12", label: "新增条目" },
            { value: "5", label: "剧情解析" },
            { value: "2", label: "新专题" },
          ].map((item) => (
            <div key={item.label} className="rounded-md bg-background-50/80 py-2">
              <p className="font-heading text-lg font-semibold text-accent-800">{item.value}</p>
              <p className="text-[10px] text-accent-700">{item.label}</p>
            </div>
          ))}
        </div>
        <Link
          to="/special"
          className="mt-3 flex items-center justify-center gap-1 whitespace-nowrap rounded-md bg-accent-500 py-2 text-[12px] font-medium text-primary-950 transition-colors hover:bg-accent-400"
        >
          进入专题合集
          <i className="ri-arrow-right-line text-xs" />
        </Link>
      </div>
    </aside>
  );
}